var map = {
	"./seq1.png": "7b5d",
	"./seq10.png": "9d76c",
	"./seq11.png": "bde3",
	"./seq12.png": "855d",
	"./seq13.png": "f3bc",
	"./seq14.png": "fcf7",
	"./seq2.png": "4812",
	"./seq3.png": "3d6d",
	"./seq4.png": "0bc2",
	"./seq5.png": "db6e",
	"./seq6.png": "8df4",
	"./seq7.png": "862b",
	"./seq8.png": "cb3a",
	"./seq9.png": "b6f1",
	"./spritesheets.png": "0027"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "66d5";